<template>
    <!--  个人中心 -->
    <div class="personal-center content">
        <el-tabs v-model="activeName">

            <el-tab-pane
                v-for="tab in allowTab"
                :key="tab.name"
                :label="tab.label"
                :name="tab.name"
            >
            </el-tab-pane>
        </el-tabs>
        <div class="component-container">
            <component :ref="activeName"
                       hide-navigate
                       :is="activeName"></component>
        </div>
    </div>
</template>
<script>
import current from "../seal/current.vue";
import mould from "../mould/index.vue";
import seal from "../seal/index.vue";
import sign from "../sign/index.vue";
import verify from "../verify/index.vue";
import personal from "../sign/signatory.vue";
import sealrecord from "../seal/create-record.vue";
import access from "../access/index.vue";

export default {
    name: "PersonalCenter",
    components: {
        sealrecord, // 印章备案
        current, // 当前印章
        seal, // 印章管理
        sign, // 我要签章
        verify, // 我要验签
        personal, // 个人签名
        access, // 访问管理
        mould, // 印模管理
    },
    data () {
        return {
            activeName: "sign",
            currentModules: [],
        };
    },
    watch: {
        activeName: {
            handler (nv) {
                this.$router.replace({ query: { tab: nv } });
            }
        },
        quser: {
            handler (nv) {
                if (nv.user) {
                    if (!this.currentActive) {
                        this.activeName = this.allowTab[0].name;
                    } else {
                        this.activeName = this.currentActive;
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.getCurrentModules();
    },
    methods: {
        async getCurrentModules() {
            try {
                let resp = await this.axios({
                    url: '/menu/app',
                    method: 'GET',
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.currentModules = resp.result;
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    computed: {
        quser () {
            return this.$store.getters.quser;
        },
        currentActive () {
            return this.$route.query.tab;
        },
        allowTab() {
            const menuTab = [
                {
                    label: "印模管理",
                    name: "mould",
                    flag: 'SEAL_MOULD_MANAGE',
                },
                {
                    label: "当前印章",
                    name: "current",
                    flag: 'CURRENT_SEAL',
                },
                {
                    label: "印章管理",
                    name: "seal",
                    flag: 'SEAL_MANAGE',
                },
                {
                    label: "个人签名",
                    name: "personal",
                    flag: 'PERSONAL_SIGN',
                },
                {
                    label: "我要签章",
                    name: "sign",
                    flag: 'SIGN',
                },
                {
                    label: "我要验签",
                    name: "verify",
                    flag: 'VERIFY',
                },
                // {
                //     label: "印章备案",
                //     name: "sealrecord",
                //     flag: '',
                // },
                {
                    label: "访问管理",
                    name: "access",
                    flag: 'ACCESS_MANAGE',
                },
            ];
            return menuTab.reduce((pre, cur) => {
                console.log(pre)
                if (this.currentModules.includes(cur.flag)) {
                    pre.push(cur);
                }
                return pre;
            }, []);
        }
    }
};
</script>
<style lang="less" scoped>
.personal-center {
    display: block !important;
    padding: 15px;
    flex: 1;

    .component-container {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>

